import React, {Component} from 'react'
import {toJS} from 'mobx'
import {inject, observer} from 'mobx-react'
import {getPaginationConfig} from '../../../components/pagination'
import {Table, Button, Image, Drawer, Space, Form, Spin, Input, Select, Row, Col, Switch, Checkbox} from 'antd'
import {ExclamationCircleFilled, EyeOutlined, AimOutlined, UnlockOutlined, LockOutlined } from '@ant-design/icons'
import {withTranslation} from 'react-i18next'
import alertMessage from '../../../utils/alertMessage'
import moment from 'moment'
const { TextArea } = Input
const storage = window.localStorage

@inject('intelligentOutboundCallModelStore', 'intelligentOutboundCallStore', 'marketingSmsManagementStore', 'marketingSmsTemplateStore', 'accountStore')
@observer
class SearchResult extends Component {
  state = {
    visible: false,
    testSendModalVisable: false,
    record: null,
    groupVal: '',
    signNum: 0,   //签名
    characterNum: 0,  //模板内容
    suffixNum: 0,  //后缀
    strNum: 0,  //字符数
    smsNum: 0,  //短信数
    signValue: '', // 签名内容
    templateValue: '', // 模板内容
    smsEnabled: false,  // 发送短信开关状态
  }
  testFormRef = React.createRef()

  handlePageChange = (page, pageSize) => {
    const {intelligentOutboundCallModelStore} = this.props
    intelligentOutboundCallModelStore.onChangePageNumAction(page, pageSize)
  }

  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }

  handleEdit = (record) => {
    const {intelligentOutboundCallModelStore} = this.props
    intelligentOutboundCallModelStore.onGetJobAction({id: record.id}).then(res => {
      this.setState({
        visible: true,
        record: res
      })
    })
  }
  handleChange = (value) => {
    this.setState({
      visible: value
    })
  }
  // 测试发送
  handleTestSend = () => {
    let _this = this
    this.testFormRef.current.validateFields().then(fieldsValue => {
      const { intelligentOutboundCallStore, marketingSmsManagementStore } = this.props
      const { record } = this.state
      const { callerList } = intelligentOutboundCallStore
      const { groupList } = marketingSmsManagementStore

      // 通用参数
      const paramsBase = {
        taskName: '模型测试 - ' + moment().format('YYYY-MM-DD HH:mm:ss'),
        marketGroupId: fieldsValue?.marketGroupId,
        expoResume: '其他',
        sceneModelId: record?.id,
        sceneModelDataId: record?.dataId,
        callerId: callerList?.[0]?.callerNumber || '',
        smsEnabled: _this.state.smsEnabled ? 1 : 0,
        // smsOn: fieldsValue?.smsOn,
        smsOnConnected: fieldsValue?.smsOn?.includes('1') ? 1 : 0,
        smsOnUnanswered: fieldsValue?.smsOn?.includes('2') ? 1 : 0,
        smsSignId: fieldsValue?.smsSignId,
        smsTemplateId: fieldsValue?.smsTemplateId,
        smsPreview: fieldsValue?.smsPreview,
      }

      let phoneList = []

      // 普通短信校验
      const receiver = this.testFormRef.current.getFieldValue('testPhoneArea')
      if (!receiver) {
        alertMessage.error("请输入测试手机号").then()
        return
      }
      const regPhone = /^((1[3,5,7,8,9][0-9])|(14[5,7])|(17[0,6,7,8])|(19[7]))\d{8}$/
      const arr = receiver.replace(/，/g, ',').split(',')
      const okArr = arr.filter(a => regPhone.test(a)) ?? []
      const failedArr = arr.filter(a => !regPhone.test(a)) ?? []
      if (failedArr.length > 0) {
        let error = "错误的手机号：" + failedArr.join(',') + " 请重新输入"
        alertMessage.error(error, 5).then()
        return
      }
      if (okArr.length > 10) {
        alertMessage.error("当前测试手机号只允许10个以内的手机号").then()
        return
      }
      phoneList = okArr
      
      const maxNum = groupList.find(a => a.id === fieldsValue?.marketGroupId)?.aiMaxConcurrency
      const params = {
        ...paramsBase,
        phoneNumbers: phoneList,
        maxConcurrency: phoneList.length < maxNum ? phoneList.length : maxNum,
      }
      intelligentOutboundCallStore.onSendTestPhone(params).then(() => {
        this.setState({ testSendModalVisable: false })
      })
    }).catch(() => {})
  }
  //关闭测试发送窗口
  handleCancelTestSend = () => {
    this.setState({ 
      testSendModalVisable: false,
      smsEnabled: false,
      groupVal: '',
    })
  }
  // 显示测试发送窗口
  handleShowTestSend = (record) => {
    this.setState({ 
      testSendModalVisable: true,
      record
    })
  }
  handleChangeActive = (record) => {
    const {intelligentOutboundCallModelStore} = this.props
    intelligentOutboundCallModelStore.onChangeStatus({
      'status': record?.status === 0 ? 1 : record?.status === 1 ? 0 : null,
      'id': record?.id,
    })
  }
  onChangeGroup = (value) => {
    const {accountStore, marketingSmsManagementStore, marketingSmsTemplateStore} = this.props
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    this.testFormRef.current.setFieldsValue({
      'smsEnabled': false,
      'smsOn': ['1'],
      'smsOnConnected': 0,
      'smsOnUnanswered': 0,
      'smsSignId': undefined,
      'smsTemplateId': undefined,
      'smsPreview': undefined,
    })
    this.setState({
      groupVal: value,
      characterNum: 0,
      strNum: 0, 
      smsNum: 0,
      smsEnabled: false,
    })
    // 加载短信签名列表
    marketingSmsManagementStore.onGetSign({
      marketGroupId: value,
      templateType: '1',
      isPowerUser : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
    })
    // 加载短信模板列表
    marketingSmsTemplateStore.onSearchAction({
      templateType: '1',
      status: '1',
      isPowerUser : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
      marketGroupId: value,
      page: 1, 
      size: 999999
    })
  }
  // 修改 签名
  onChangeSign = (e,option) => {
    const signSun = (option?.children || '').length
    const strSum = parseInt(signSun)+parseInt(this.state.characterNum)+parseInt(this.state.suffixNum)
    this.setState({
      signNum: signSun,
      strNum: strSum,
      smsNum: strSum > 70 ? Math.ceil(strSum/67) : 1,
      signValue: option?.children,
    })
    this.testFormRef.current.setFieldsValue({
      smsPreview: option?.children + this.state.templateValue,
    })
  }
  // 修改 模板
  onChangeTemplate = (e) => {
    const { marketingSmsTemplateStore } = this.props
    const { jobList } = marketingSmsTemplateStore
    const templateSun = parseInt((jobList?.find(a=>a?.id === e)?.template || '').length)
    const suffixSum = parseInt((jobList?.find(a=>a?.id === e)?.templateSuffix || '').length)
    const strSum = parseInt(this.state.signNum)+templateSun+suffixSum
    this.setState({
      characterNum: templateSun,
      suffixNum: suffixSum,
      strNum: strSum,
      smsNum: strSum > 70 ? Math.ceil(strSum/67) : 1,
      templateValue: jobList?.find(a=>a?.id === e)?.template + jobList?.find(a=>a?.id === e)?.templateSuffix,
    })
    this.testFormRef.current.setFieldsValue({
      smsPreview: this.state.signValue + jobList?.find(a=>a?.id === e)?.template + jobList?.find(a=>a?.id === e)?.templateSuffix,
    })
  }
  render() {
    const {intelligentOutboundCallModelStore, intelligentOutboundCallStore, marketingSmsManagementStore, marketingSmsTemplateStore, t} = this.props
    const {isTestSendFetching} = intelligentOutboundCallStore
    const { groupList, signList } = marketingSmsManagementStore
    const { visible, testSendModalVisable, record } = this.state
    const themeStyle = JSON.parse(storage.getItem('themeStyle'))
    const {pageNo, pageSize, itemCount} = intelligentOutboundCallModelStore
    const pagination = getPaginationConfig(pageNo, pageSize, itemCount, this.handlePageChange)
    const columns = [
      { 
        align: 'center',
        width: 80,
        fixed: 'left',
        title: t(`marketingManagement.status`),
        dataIndex: 'status',
        key: 'status',
        ellipsis: true,
        render:text => <div style={{
          display: 'inline-block',
          height: 24,
          width: 24,
          lineHeight: '24px',
          fontSize: 12,
          borderRadius: 24,
          color: 'white',
          textAlign: 'center',
          background: text === 0 ? themeStyle?.statusColor?.split(',')?.[1] || '#ef6e6e' : themeStyle?.statusColor?.split(',')?.[0] || '#97cf7c'
        }} title={text === 0 ? '停用' : '启用'}>{text === 0 ? '停' : '启'}</div>
      },
      {
        title: t(`outboundCall.id`),
        dataIndex: 'id',
        key: 'id',
        ellipsis: true
      },
      {
        title: t(`outboundCall.modelName`),
        dataIndex: 'modelName',
        key: 'modelName',
        ellipsis: true
      },
      {
        title: t(`outboundCall.createTime`),
        dataIndex: 'createTime',
        key: 'createTime',
        ellipsis: true
      },
      {
        title: t(`outboundCall.updateTime`),
        dataIndex: 'updateTime',
        key: 'updateTime',
        ellipsis: true
      },
      {
        align: 'center',
        title: t(`general.action`),
        key: 'action',
        render: (text, record) => (
          <>
            <Button type="link" onClick={() => this.handleEdit(record)} icon={<EyeOutlined />} title={t(`general.view`)}/>
            <Button type="link" onClick={() => this.handleChangeActive(record)}
                      icon={record.status === 0 ? <LockOutlined/> : <UnlockOutlined/>}
                      title={record.status === 0 ? t(`general.enable`) : t(`general.disable`)}/>
            {record.status === 1 && <Button type="link" onClick={() => this.handleShowTestSend(record)} icon={<AimOutlined />} title={t(`general.test`)}/>}
          </>
        )
      }
    ]
    
    return (
      <>
        <Table 
          className="searchResult" 
          dataSource={toJS(intelligentOutboundCallModelStore.jobList)} 
          pagination={pagination} 
          rowKey="id" 
          rowClassName={this.getRowClassName}
          columns={columns}
          scroll={{x: '100%'}}
        />
        <Image
          width={200}
          style={{
            display: 'none',
          }}
          src={record?.obsUrl}
          preview={{
            visible,
            src: record?.obsUrl,
            onVisibleChange: (value) => {
              this.handleChange(value)
            },
          }}
        />
        <Drawer
          title="测试发送"
          autoFocus={true}
          destroyOnClose={true}
          placement="top"
          closable={true}
          onClose={this.handleCancelTestSend}
          visible={testSendModalVisable}
          size='small'
          extra={
            <Space>
              <Button type="primary" shape="round" loading={isTestSendFetching} onClick={this.handleTestSend}>{t('general.testSend')}</Button>
              <Button shape="round" onClick={this.handleCancelTestSend}>{t('general.close')}</Button>
            </Space>
          }
          className="testSendDrawer"
        >
          <Spin spinning={isTestSendFetching}>
            <Form ref={this.testFormRef} key="testForm">
                <Row gutter={[10, 10]} style={{padding: '0 50px'}}>
                  <Col span={4}>
                    <Form.Item name="marketGroupId" label={t(`marketingManagement.marketingGroup`)} labelCol={{span: 9}} wrapperCol={{span: 15}}
                      rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`marketingManagement.marketingGroup`)}`}]}
                      >
                      <Select placeholder={t(`general.pleaseSelect`)} showSearch filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      } onChange={this.onChangeGroup} style={{width: '95%'}}>
                        {groupList?.map(item => (<Select.Option key={item.id} value={item.id}>{item.groupName}</Select.Option>))}
                      </Select>
                    </Form.Item>
                  </Col>
                  {/* 发送短信设置 */}
                  <Col span={4}>
                    <Form.Item name="smsEnabled" label={t(`outboundCall.sendSms`)}>
                      <Switch 
                        checked={this.state.smsEnabled}
                        onChange={(checked) => {
                          this.setState({ smsEnabled: checked })
                          this.testFormRef.current.setFieldsValue({
                            'smsOn': ['1'],
                            'smsOnConnected': 0,
                            'smsOnUnanswered': 0,
                            'smsSignId': undefined,
                            'smsTemplateId': undefined,
                            'smsPreview': undefined,
                          })
                        }}
                      />
                    </Form.Item>
                  </Col>
                  
                  {/* 短信发送条件 - 仅在发送短信开启时显示 */}
                  {this.state.smsEnabled && (
                    <>
                      <Col span={4}>
                        <Form.Item name="smsOn">
                          <Checkbox.Group>
                            <Checkbox value="1">{t(`outboundCall.sendAfterConnected`)}</Checkbox>
                            <Checkbox value="2">{t(`outboundCall.sendAfterNotConnected`)}</Checkbox>
                          </Checkbox.Group>
                        </Form.Item>
                      </Col>
                      <Col span={4}>
                        <Form.Item name="smsSignId" label={t(`outboundCall.smsSignature`)}
                          disabled={!this.state.groupVal}
                          rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`outboundCall.smsSignature`)}`}]}
                        >
                          <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          } onChange={this.onChangeSign} disabled={!this.state.groupVal}>
                            {signList?.filter(a=>a?.marketingGroupId ===this.state.groupVal)?.map(item => (<Select.Option key={item.id} value={item.id}>{`【${item.sign}】`}</Select.Option>))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={4}>
                        <Form.Item name="smsTemplateId" label={t(`outboundCall.smsTemplate`)}
                          disabled={!this.state.groupVal}
                          rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`outboundCall.smsSignature`)}`}]}
                        >
                          <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          } onChange={this.onChangeTemplate} disabled={!this.state.groupVal}>
                            {marketingSmsTemplateStore.jobList?.filter(a=>a?.marketingGroupId ===this.state.groupVal)?.map(item => (<Select.Option key={item.id} value={item.id}>{item.templateName}</Select.Option>))}
                          </Select>
                        </Form.Item>
                      </Col>
                    </>
                  )}
                </Row>
                <Row gutter={[10, 10]} style={{padding: '0 50px'}}>
                  {this.state.smsEnabled && (
                      <Col span={12}>
                        <Form.Item name="smsPreview" label={t(`outboundCall.smsPreview`)} labelCol={{span: 3}} wrapperCol={{span: 21}} style={{marginBottom: 0}}>
                          <TextArea disabled rows={5} style={{ backgroundColor: '#f5f5f5' }} />
                        </Form.Item>
                        <Form.Item labelCol={{span: 3}} wrapperCol={{span: 21}} style={{marginBottom: 0}}>
                          <div className='interSum' style={{border: 0, textAlign: 'left', marginLeft: 100}}>
                            {t(`marketingManagement.total4`)}
                            <span style={{color: '#ff5200'}}>{this.state.strNum}</span>
                            {t(`marketingManagement.total2`)}
                            <span style={{color: 'red'}}>{this.state.smsNum}</span>
                            {t(`marketingManagement.total3`)}
                          </div>
                        </Form.Item>
                      </Col>
                  )}
                  <Col span={12}>
                    <Form.Item name="testPhoneArea" label="测试手机号" preserve={true} labelCol={{span: 3}} wrapperCol={{span: 21}} style={{marginBottom: 0}}>
                      <TextArea rows={5} allowClear={true} placeholder="请输入正确的手机号，多个手机号使用逗号分隔，测试手机号最多输入10个手机号" />
                    </Form.Item>
                    <Form.Item name="testEmailAreaNotice" style={{marginBottom: 0}}>
                      <div className="f_red" style={{marginLeft: '110px'}}><ExclamationCircleFilled/> 请输入正确的手机号，多个手机号使用逗号分隔，测试手机号最多输入10个手机号
                      </div>
                    </Form.Item>
                  </Col>
                </Row>
            </Form>
          </Spin>
        </Drawer>
      </>
    )
  }
}


export default withTranslation()(SearchResult)
